import { prisma, type Prisma, Tag } from "client";

export const createTag = async (
  data: Prisma.TagCreateInput,
  eventId: string
) => {
  const tag = await getTagByName(data.name, eventId);
  if (tag) {
    return tag;
  }
  return prisma.tag.create({
    data,
  });
};
export const getTagByName = async (name: string, eventId: string) => {
  return prisma.tag.findFirst({
    where: {
      eventId,
      name: {
        equals: name.trim(),
        mode: "insensitive",
      },
    },
  });
};

export const getTagById = async (id: string) => {
  return prisma.tag.findUnique({ where: { id } });
};

export const updateTag = async (id: string, data: Prisma.TagUpdateInput) => {
  return prisma.tag.update({ where: { id }, data });
};

export const deleteTag = async (id: string) => {
  return prisma.tag.delete({ where: { id } });
};

export const listTags = async (options: {
  eventId?: string;
  search?: string;
  page?: number;
  limit?: number;
  type?: "User" | "Meeting";
}) => {
  const { eventId, search, page = 1, limit = 10, type } = options;
  const trimSearch = search?.trim();
  const where: any = {
    ...(eventId ? { eventId } : {}),
    ...(trimSearch
      ? {
          name: {
            contains: trimSearch,
            mode: "insensitive",
          },
        }
      : {}),
    ...(type && type === "User" ? { userIds: { isEmpty: false } } : {}),
    ...(type === "Meeting" ? { meetingIds: { isEmpty: false } } : {}),
  };

  const [tags, total] = await Promise.all([
    prisma.tag.findMany({
      where,
      skip: (page - 1) * limit,
      take: limit,
      orderBy: { createdAt: "desc" },
    }),
    prisma.tag.count({ where }),
  ]);

  const hasNextPage = (page - 1) * limit + limit < total;

  return {
    tags,
    pagination: {
      total,
      totalPages: Math.ceil(total / limit),
      hasNextPage,
      currentPage: page,
      hasPreviousPage: page > 1,
    },
  };
};
